export default IconScoreboard => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-scoreboard" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
  <path d="M12 5v2" />
  <path d="M12 10v1" />
  <path d="M12 14v1" />
  <path d="M12 18v1" />
  <path d="M7 3v2" />
  <path d="M17 3v2" />
  <path d="M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
  <path d="M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
</svg>`;